export default {
  "generalSettings.title": "General Settings",
  "generalSettings.company": "Company",
};
